// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-form-actions[data-v-dc65e330]{align-items:center;display:flex;flex-wrap:wrap;gap:var(--spacing-md-3);justify-content:flex-end;margin-top:var(--spacing-md-3)}.base-form-actions>*[data-v-dc65e330]{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
